import Vue from "vue";
import VueRouter from "vue-router";

let Home = () => import("../views/Home.vue");
let Classification = () => import("../views/Classification.vue");
let Details = () => import("../views/Details.vue");
let CoursesDetail = () => import("../views/CoursesDetail.vue");

let About = () => import("../views/About.vue");
let Search = () => import("../views/Search.vue");

import { getToken, map } from "../utils/util.js";
Vue.use(VueRouter);
// 获取原型对象上的push函数
const originalPush = VueRouter.prototype.push;
// 修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};
const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/classification",
    name: "Classification",
    component: Classification,
  },
  {
    path: "/details",
    name: "Details",
    component: Details,
  },
  {
    path: "/coursesDetail",
    name: "CoursesDetail",
    component: CoursesDetail,
  },
  {
    path: "/search",
    name: "Search",
    component: Search,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});
// router.beforeEach((to, from, next) => {
//   let toPath = to.path;
//   console.log(toPath);
//   // 允许访问 /home
//   if (toPath === "/" || toPath === "/stuH5" || toPath === "/stuH5Form") {
//     return next();
//   }
//   let token = getToken();
//   // 如果没有 token，重定向到根路径
//   if (toPath == "/home") {
//     setTimeout(() => {
//       if (!getToken()) {
//         return next("/");
//       }
//       // 继续路由
//       next();
//     }, 500);
//   } else {
//     if (!getToken()) {
//       return next("/");
//     }
//     // 继续路由
//     next();
//   }
// });
// router.beforeEach((to, from, next) => {
//   if (to.path === "/") {
//     return next();
//   }
//   getToken() ? next() : next("/");
// });

router.afterEach((to, from, next) => {
  // document.title = map.get(to.path);
  document.title = map.get(to.path) || "北京市专业技术人才知识更新工程";
});

export default router;
